import React from 'react'
import GMACourseForm from '../../features/gmaCourse/GMACourseForm'

const GMACourse = () => {
    return (
        <GMACourseForm />
    )
}

export default GMACourse